



















// @ts-nocheck
import { Component, Vue, Prop } from 'vue-property-decorator'
import AsyncComputed from 'vue-async-computed-decorator'
import { Auth } from 'aws-amplify'
import { routes, isAuthorized } from '@/router/index'
import LanguageSelector from '@/components/LanguageSelector.vue'
import { query as tenant } from '@/store/tenant'

const capitalize = s => (s && String(s[0]).toUpperCase() + String(s).slice(1)) || ""

@Component<AppBar>({
  components: {
    LanguageSelector
  },
  apollo: {
    tenant
  }
})
export default class AppBar extends Vue {
  // @ts-ignore
  publicPath = process.env.BASE_URL

  @AsyncComputed()
  async user() {
    return await Auth.currentSession()
  }

  get tenantName() {
    if(this.tenant?.id === "tenant-osnabrueck") {
      return "Stadt Osnabrück und Landkreis Osnabrück"
    }
    if(this.tenant?.id?.startsWith("tenant-")) {
      return capitalize(this.tenant.id.split("-")[1])
    } else {
      return capitalize(this.tenant?.id)
    }
  }

  isAuthorizedTo(name: string, config = routes) {
    for (const route of config) {
      if (route.name === name) {
        return isAuthorized(route, this.user)
      }
      if (route.children != null && this.isAuthorizedTo(name, route.children))
        return true
    }
    return false
  }
}
